<!-- Modal -->
<div class="col-lg-12 col-xxl-12 mt-3 px-lg-4 pt-3 z-index--top">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-pasajeros-edit">
        <div class="container">
            <h5 class="title-bg mb-4">Información del pasajero</h5>

            <div class="row">
                <div class="col-md-12 mt-12">
                    <div class="row g-3 mb-0 align-items-center">
                        <div class="col-5">
                            <label class="form-label">Nombre y Apellido</label>
                        </div>
                        <div class="col-7">
                            <input formControlName="nombre" type="text" class="form-control w-100 border-secondary rounded-pill">
                        </div>
                        <div class="col-12 mt-0">
                            <hr>
                        </div>
                    </div>
                    <div class="row g-3 mb-0 align-items-center">
                        <div class="col-5">
                            <label class="form-label">Tipo de Documento</label>
                        </div>
                        <div class="col-7">
                            <select formControlName="tipodoc" class="form-control w-100 border-secondary rounded-pill">
                              <option value="DNI">DNI</option>
                              <option value="Otro">Otro</option>
                            </select>
                        </div>
                        <div class="col-12 mt-0">
                            <hr>
                        </div>
                    </div>
                    <div class="row g-3 mb-0 align-items-center">
                        <div class="col-5">
                            <label class="form-label">Numero Documento</label>
                        </div>
                        <div class="col-7">
                            <input formControlName="documento" type="text" class="form-control w-100 border-secondary rounded-pill">
                        </div>
                        <div class="col-12 mt-0">
                            <hr>
                        </div>
                    </div>
                    <div class="row g-3 mb-0 align-items-center">
                        <div class="col-5">
                            <label class="form-label">Fecha de Nacimiento</label>
                        </div>
                        <div class="col-7">
                            <input id="fecha-nacimiento" formControlName="fechanacimiento" type="date" class="form-control w-100 border-secondary rounded-pill">
                        </div>
                        <div class="col-12 mt-0">
                            <hr>
                        </div>
                    </div>
                    <div class="row g-3 mb-0 align-items-center">
                        <div class="col-5">
                            <label class="form-label">Teléfono</label>
                        </div>
                        <div class="col-7">
                            <input formControlName="telefono" type="tel" class="form-control w-100 border-secondary rounded-pill">
                        </div>
                        <div class="col-12 mt-0">
                            <hr>
                        </div>
                    </div>
                    <div class="row g-3 mb-0 align-items-center">
                        <div class="col-5">
                            <label class="form-label">Correo Electrónico</label>
                        </div>
                        <div class="col-7">
                            <input formControlName="email" type="mail" class="form-control w-100 border-secondary rounded-pill" placeholder="juanperez@gmail.com">
                        </div>
                        <div class="col-12 mt-0">
                            <hr>
                        </div>
                    </div>
                </div>
            </div>

            <h5 class="title-bg mb-4 mt-4">Información del viaje</h5>
            <div class="row">
                <div class="col-md-12 mt-12">
                    <div class="row g-3 align-items-center">
                        <div class="col-5">
                            <label class="form-label">Fecha de viaje</label>
                        </div>
                        <div class="col-4">
                            <input id=fecha-viaje type="text" class="form-control w-100 border-secondary rounded-pill" disabled>
                        </div>
                        <div class="col-12 mt-0">
                            <hr>
                        </div>
                    </div>
                    <div class="row g-3 align-items-center">
                        <div class="col-5">
                            <label class="form-label">Destino</label>
                        </div>
                        <div class="col-7">
                            <input id=destino-viaje type="text" class="form-control w-100 border-secondary rounded-pill" disabled>
                        </div>
                        <div class="col-12 mt-0">
                            <hr>
                        </div>
                    </div>
                    <div class="row g-3 align-items-center">
                        <div class="col-5">
                            <label class="form-label">Cuenta</label>
                        </div>
                        <div class="col-7">
                            <input id=estado-cuenta type="text" class="form-control w-100 border-secondary rounded-pill" disabled>
                        </div>
                        <div class="col-12 mt-0">
                            <hr>
                        </div>
                    </div>
                    <div class="row g-3 align-items-center">
                        <div class="col-6">
                            <div class="row">
                                <div class="col-4">
                                    <label class="form-label">Debe</label>
                                </div>
                                <div class="col-8">
                                    <input id=debe type="text" class="form-control w-100 border-secondary rounded-pill" disabled>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="row">
                                <div class="col-4">
                                    <label class="form-label">Pagó</label>
                                </div>
                                <div class="col-8">
                                    <input formControlName=pagado type="string" class="form-control w-100 border-secondary rounded-pill">
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mt-0">
                            <hr>
                        </div>
                    </div>
                    <div class="row g-3 align-items-center">
                        <div class="col-5">
                            <label class="form-label">Precio Total</label>
                        </div>
                        <div class="col-7">
                            <input id=precio-total type="text" class="form-control w-100 border-secondary rounded-pill" disabled>
                        </div>
                        <div class="col-12 mt-0">
                            <hr>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 d-flex justify-content-between mb-4">
                    <button (click)="this.activeModal.dismiss()" class="btn btn-outline-primary btn-lg rounded-pill">Cancelar</button>
                    <button type=submit class="btn btn-lg rounded-pill btn-primary">Guardar cambios</button>
                </div>
            </div>
        </div>
    </form>
</div>
